export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/tl.lyaml"));
at({ "tl": { "public": { "sampleString": "Sample string" } } });
};